import type { BackendClients } from '../contracts';
import { FirebaseActionItemsClient } from './firebase-action-items-client';
import { FirebaseAdminProjectsClient } from './firebase-admin-projects-client';
import { FirebaseActivityLogClient } from './firebase-activity-log-client';
import { FirebaseBlobStoreClient } from './firebase-blob-store-client';
import { FirebaseCommunicationHistoryClient } from './firebase-communication-history-client';
import { FirebaseCommandClient } from './firebase-command-client';
import { FirebaseIdentityClient } from './firebase-identity-client';
import { FirebaseLineNotesClient } from './firebase-line-notes-client';
import { FirebaseOrgMembershipClient } from './firebase-org-membership-client';
import { FirebaseOrganizationAdminClient } from './firebase-organization-admin-client';
import { FirebaseOrganizationInventoryClient } from './firebase-organization-inventory-client';
import { FirebasePerformanceLogClient } from './firebase-performance-log-client';
import { FirebaseProjectAccessClient } from './firebase-project-access-client';
import { FirebaseProjectBudgetClient } from './firebase-project-budget-client';
import { FirebaseProjectCatalogClient } from './firebase-project-catalog-client';
import { FirebaseProjectDataClient } from './firebase-project-data-client';
import { FirebaseProjectScheduleClient } from './firebase-project-schedule-client';
import { FirebaseTranscriptionClient } from './firebase-transcription-client';
import { FirebaseProjectWriteClient } from './firebase-project-write-client';
import { FirebaseRawNotesClient } from './firebase-raw-notes-client';
import { FirebaseScriptJobClient } from './firebase-script-job-client';
import { FirebaseTelemetryClient } from './firebase-telemetry-client';
import { FirebaseUserAssetClient } from './firebase-user-asset-client';

export function createFirebaseBackend(): BackendClients {
  const commands = new FirebaseCommandClient();
  const orgMemberships = new FirebaseOrgMembershipClient();

  return {
    environment: { name: 'firebase' },
    actionItems: new FirebaseActionItemsClient(),
    activityLog: new FirebaseActivityLogClient(),
    adminProjects: new FirebaseAdminProjectsClient(),
    blobs: new FirebaseBlobStoreClient(commands),
    commands,
    communicationHistory: new FirebaseCommunicationHistoryClient(),
    identity: new FirebaseIdentityClient(),
    lineNotes: new FirebaseLineNotesClient(),
    orgMemberships,
    organizationAdmin: new FirebaseOrganizationAdminClient(),
    organizationInventory: new FirebaseOrganizationInventoryClient(),
    performanceLogs: new FirebasePerformanceLogClient(),
    projectAccess: new FirebaseProjectAccessClient(),
    projectBudgets: new FirebaseProjectBudgetClient(),
    projectCatalog: new FirebaseProjectCatalogClient(orgMemberships),
    projectData: new FirebaseProjectDataClient(),
    projectSchedule: new FirebaseProjectScheduleClient(),
    projectWrites: new FirebaseProjectWriteClient(commands),
    rawNotes: new FirebaseRawNotesClient(),
    scriptJobs: new FirebaseScriptJobClient(),
    telemetry: new FirebaseTelemetryClient(),
    transcription: new FirebaseTranscriptionClient(),
    userAssets: new FirebaseUserAssetClient(),
  };
}

export { FirebaseActionItemsClient };
export { FirebaseActivityLogClient };
export { FirebaseBlobStoreClient };
export { FirebaseCommunicationHistoryClient };
export { FirebaseCommandClient };
export { FirebaseIdentityClient };
export { FirebaseLineNotesClient };
export { FirebaseOrgMembershipClient };
export { FirebaseOrganizationAdminClient };
export { FirebaseOrganizationInventoryClient };
export { FirebaseProjectAccessClient };
export { FirebaseProjectDataClient };
export { FirebaseProjectScheduleClient };
export { FirebaseTranscriptionClient };
export { FirebaseProjectWriteClient };
export { FirebaseRawNotesClient };
export { FirebaseScriptJobClient };
export { FirebaseTelemetryClient };
export { FirebaseUserAssetClient };
